import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourceNone extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <g>
                    <path d="M 2,7 V 8 H 3 V 7 Z"/>
                    <path d="M 4,7 V 8 H 5 V 7 Z"/>
                    <path d="M 6,7 V 8 H 7 V 7 Z"/>
                    <path d="M 8,7 V 8 H 9 V 7 Z"/>
                    <path d="m 10,7 v 1 h 1 V 7 Z"/>
                    <path d="m 12,7 v 1 h 1 V 7 Z"/>
                    <path d="m 14,7 v 1 h 1 V 7 Z"/>
                    <path d="m 16,7 v 1 h 1 V 7 Z"/>
                    <path d="m 18,7 v 1 h 1 V 7 Z"/>
                    <path d="m 20,7 v 1 h 1 V 7 Z"/>
                    <path d="m 22,7 v 1 h 1 V 7 Z"/>
                </g>
                <rect width="10" x="12" y="12" rx="0" height="10"/>
            </g>
        );
    }

}


export default ActiveResourceNone;